var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lucide lucide-ship",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.189V14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.df841ce90317dcf672e0b18c32779871.svg";
export { ForwardRef as ReactComponent };